import { Fragment, useEffect, useState } from "react";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Message from "../Message/Message";

const Header = (props) => {
  const location = useLocation();
  const [isActive, setIsActive] = useState("blog");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("hkblog-theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("hkblog-theme", theme);
  }, [theme]);

  useEffect(() => {
    location.pathname === "/profile"
      ? setIsActive("profile")
      : setIsActive("blog");
  }, [location]);

  const logoutHandler = () => {
    props.logout();
    setIsActive("blog");
    setIsMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <Fragment>
      <div className={styles["main-header"]}>
        {props.isMessage && (
          <div className={styles["session-message"]}>
            <Message
              type="error"
              message={props.message}
              cross={props.crossHandler}
            />
          </div>
        )}
        <div className={styles["logo"]}>
          <Link to="/" onClick={closeMobileMenu}>
            <img src="https://res.cloudinary.com/dljf2mhkb/image/upload/v1769960213/course_images/f964f226-2818-4360-bb15-a305e79bcf08-RT2_g9dboy.png.png" alt="logo"></img>
          </Link>
          <Link to="/" onClick={closeMobileMenu}>
            <h1>
              Hacker<span>bl</span>og
            </h1>
          </Link>
        </div>

        <div className={styles["hamburger"]} onClick={toggleMobileMenu}>
          <div className={`${styles.bar} ${isMobileMenuOpen ? styles.open1 : ""}`}></div>
          <div className={`${styles.bar} ${isMobileMenuOpen ? styles.open2 : ""}`}></div>
          <div className={`${styles.bar} ${isMobileMenuOpen ? styles.open3 : ""}`}></div>
        </div>

        <div className={`${styles["menu-wrapper"]} ${isMobileMenuOpen ? styles["menu-open"] : ""}`}>
          <div className={styles["navlink"]}>
            <Link to="/">
              <p
                onClick={() => {
                  setIsActive("blog");
                  closeMobileMenu();
                }}
                className={isActive === "blog" ? styles["active"] : ""}
              >
                Blog
              </p>
            </Link>
            <a href="https://lms.hackerblog.co.in" target="_blank" rel="noopener noreferrer">
              <p onClick={closeMobileMenu}>Online Courses</p>
            </a>
            <a href="https://news.hackerblog.co.in" target="_blank" rel="noopener noreferrer">
              <p onClick={closeMobileMenu}>News</p>
            </a>
            <a href="https://tutorials.hackerblog.co.in/" target="_blank" rel="noopener noreferrer">
              <p onClick={closeMobileMenu}>Tutorials</p></a>
            <a href="https://ide.hackerblog.co.in" target="_blank" rel="noopener noreferrer">
              <p onClick={closeMobileMenu}>Online Complier</p>
            </a>
            <a href="https://blog.hackerblog.co.in" target="_blank" rel="noopener noreferrer">
              <p onClick={closeMobileMenu}>Articles</p></a>

            {props.isLogin && (
              <Link to="/profile">
                <p
                  onClick={() => { setIsActive("profile"); closeMobileMenu(); }}
                  className={isActive === "profile" ? styles["active"] : ""}
                >
                  Profile
                </p>
              </Link>
            )}
            <Link to="/about">
              <p
                onClick={() => {
                  setIsActive("about");
                  closeMobileMenu();
                }}
                className={isActive === "about" ? styles["active"] : ""}
              >
                About us
              </p>
            </Link>
            <Link to="/contact">
              <p
                onClick={() => {
                  setIsActive("contact");
                  closeMobileMenu();
                }}
                className={isActive === "contact" ? styles["active"] : ""}
              >
                Contact
              </p>
            </Link>
          </div>
          <div className={styles["header-actions"]}>
            <button
              id="theme-toggle-btn"
              className={styles["theme-toggle"]}
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
              title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
            >
              <span className={`${styles["toggle-icon"]} ${theme === "dark" ? styles["icon-visible"] : ""}`}>
                {/* Sun icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5"></circle>
                  <line x1="12" y1="1" x2="12" y2="3"></line>
                  <line x1="12" y1="21" x2="12" y2="23"></line>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                  <line x1="1" y1="12" x2="3" y2="12"></line>
                  <line x1="21" y1="12" x2="23" y2="12"></line>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                </svg>
              </span>
              <span className={`${styles["toggle-icon"]} ${theme === "light" ? styles["icon-visible"] : ""}`}>
                {/* Moon icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                </svg>
              </span>
            </button>
            <div className={styles["auth-btn"]}>
              {!props.isLogin ? (
                <Link to="login" onClick={closeMobileMenu}>
                  <button className={styles["login-btn"]}>Login</button>
                </Link>
              ) : (
                <button onClick={logoutHandler} className={styles["logout-btn"]}>
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
